import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

/**
 * Resets window scroll to top whenever the route path changes.
 *
 * React Router intentionally preserves scroll position across navigation —
 * that's usually wrong for page-level routes. Mount this once inside the
 * BrowserRouter and every route change lands at the top.
 *
 * Intentionally ignores hash and search changes (we want deep-link anchors
 * like #pair on /supplier-app to still work).
 */
export default function ScrollToTop() {
  const { pathname } = useLocation();

  useEffect(() => {
    // `auto` (not `smooth`) — users expect instant reset on route change;
    // smooth scrolling feels like the old page is still loading.
    window.scrollTo({ top: 0, left: 0, behavior: 'auto' });
  }, [pathname]);

  return null;
}
